import {Button, Flex, Tooltip} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAnglesDown, faAnglesUp} from "@fortawesome/free-solid-svg-icons";
import React from "react";

export const ListControls = (
    props: {
        allKeys: string[],
        expandedKeys: string[],
        onExpandAll: (keys: string[]) => void,
        onCollapseAll: () => void,
    }
) => {

    return (
        <Flex justify={'end'} gap={10}>
            <Tooltip title={'Expand all'}>
                <Button
                    icon={<FontAwesomeIcon icon={faAnglesDown}/>}
                    disabled={props.allKeys?.length == props.expandedKeys.length}
                    onClick={() => props.onExpandAll(props.allKeys)}
                />
            </Tooltip>
            <Tooltip title={'Collapse all'}>
                <Button
                    icon={<FontAwesomeIcon icon={faAnglesUp}/>}
                    disabled={props.expandedKeys.length == 0}
                    onClick={() => props.onCollapseAll()}
                />
            </Tooltip>
        </Flex>
    )
}